var React = require('react');

function Ye (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#fff","d":"M0 0h640v472.8H0z","key":0}),React.createElement("path",{"fill":"#f10600","d":"M0 0h640v157.4H0z","key":1}),React.createElement("path",{"d":"M0 322.6h640V480H0z","key":2})]));
}

Ye.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ye;

Ye.default = Ye;
